import { useState, useEffect } from "react";

const useDimensions = (ref, childSelector = ".react-pdf__Page") => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref?.current) return;

    let targetElement = ref.current;

    if (childSelector) {
      targetElement = ref.current.querySelector(childSelector);
    }

    if (!targetElement) return;

    const updateDimensions = () => {
      setDimensions({
        width: targetElement.offsetWidth,
        height: targetElement.offsetHeight,
      });
    };

    updateDimensions();

    const observer = new ResizeObserver(() => {
      updateDimensions();
    });

    observer.observe(targetElement);

    return () => {
      observer.disconnect();
    };
  }, [ref, childSelector]);

  return dimensions;
};

export default useDimensions;
